import fetcher from 'api/fetcher';

import { urlParser } from '@hh.ru/browser-api-utils';

import { CampaignDetails, setCampaignsDetails, setIsCampaignsDetailsLoading } from 'store/models/campaignsDashboard';
import { AppThunkAction } from 'store/utils';

type FetchCampaignsDetails = (options: {
    campaignIds: string[];
    abortSignal: AbortSignal;
}) => AppThunkAction<Promise<void> | null>;

export const fetchCampaignsDetails: FetchCampaignsDetails = ({ campaignIds, abortSignal }) => {
    return (dispatch) => {
        const queryStr = urlParser.stringify({
            campaignIds,
        });

        return fetcher
            .get<unknown, Record<string, CampaignDetails>>(`/api/v2/campaigns/details?${queryStr}`, {
                signal: abortSignal,
                timeout: 10000,
            })
            .then((details) => {
                dispatch([setIsCampaignsDetailsLoading(false), setCampaignsDetails(details)]);
            })
            .catch(() => {
                if (abortSignal?.aborted) {
                    return;
                }
                dispatch([setIsCampaignsDetailsLoading(false), setCampaignsDetails(null)]);
            });
    };
};
